import { useEffect, useState } from "react";
import { NAV_LINKS } from "../constants/data";
import { scrollTo } from "../utils/scroll";

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const navStyle = {
    position: "fixed" as const,
    top: 0,
    left: 0,
    right: 0,
    zIndex: 50,
    transition: "all 0.3s",
    background: scrolled ? "rgba(255,255,255,0.97)" : "transparent",
    backdropFilter: scrolled ? "blur(10px)" : "none",
    boxShadow: scrolled ? "0 2px 20px rgba(0,0,0,0.08)" : "none",
    padding: scrolled ? "12px 0" : "20px 0",
  };

  const containerStyle = {
    maxWidth: 1100,
    margin: "0 auto",
    padding: "0 20px",
    display: "flex" as const,
    alignItems: "center" as const,
    justifyContent: "space-between" as const,
  };

  return (
    <nav style={navStyle}>
      <div style={containerStyle}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 12,
            cursor: "pointer",
          }}
          onClick={() => scrollTo("hero")}
        >
          <div
            style={{
              width: 42,
              height: 42,
              borderRadius: "50%",
              background: "linear-gradient(135deg,#1d4ed8,#0d9488)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontWeight: 700,
              fontSize: 15,
              boxShadow: "0 4px 12px rgba(29,78,216,0.3)",
            }}
          >
            GM
          </div>
          <div>
            <div
              style={{
                fontWeight: 700,
                fontSize: 14,
                color: scrolled ? "#1e293b" : "white",
              }}
            >
              Dr. Gaurav B. Modi
            </div>
            <div
              style={{
                fontSize: 11,
                color: scrolled ? "#0d9488" : "#99f6e4",
              }}
            >
              Nephrologist · Kidney Transplant
            </div>
          </div>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: 28 }} className="hidden-mobile">
          {NAV_LINKS.map((link) => (
            <button
              key={link}
              onClick={() => scrollTo(link.toLowerCase())}
              style={{
                background: "none",
                border: "none",
                fontSize: 14,
                fontWeight: 500,
                color: scrolled ? "#475569" : "rgba(255,255,255,0.88)",
                cursor: "pointer",
                transition: "color 0.2s",
                padding: 0,
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLButtonElement).style.color = "#0d9488";
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLButtonElement).style.color = scrolled
                  ? "#475569"
                  : "rgba(255,255,255,0.88)";
              }}
            >
              {link}
            </button>
          ))}
          <button
            onClick={() => scrollTo("contact")}
            style={{
              background: "linear-gradient(135deg,#1d4ed8,#0d9488)",
              color: "white",
              border: "none",
              fontWeight: 700,
              fontSize: 13,
              padding: "10px 22px",
              borderRadius: 50,
              cursor: "pointer",
              boxShadow: "0 4px 14px rgba(29,78,216,0.35)",
              transition: "transform 0.2s,box-shadow 0.2s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.05)";
              e.currentTarget.style.boxShadow = "0 6px 20px rgba(29,78,216,0.4)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow = "0 4px 14px rgba(29,78,216,0.35)";
            }}
          >
            📅 Book Appointment
          </button>
        </div>
      </div>
    </nav>
  );
}
